import styled from 'styled-components';
const ResultListStyled = styled.div`
  background-color: #fff;
  border-radius: 14px;
  flex-grow: 1;
  /* padding: 8px 8px 0; */
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
  .dfirRY {
    /* width: 1640px; */
    /* border: 1px solid red; */
  }
  .MuiTabs-root {
    height: 54px;
    margin-left: 32px;
    margin-right: 32px;
    border-bottom: 1px solid #f5f5f5;
    .MuiButtonBase-root {
      height: 52px;
      width: 160px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .date-wrapper {
    display: flex;
    flex-direction: column;
  }
  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }
    span {
      font-size: 16px;
      /* color: #fff; */
    }
    .icon {
      width: 18px;
      height: 18px;
      fill: '#BDBDBD';
      > svg {
        border: 1px solid red;
      }
    }
    .MuiButtonBase-root {
      height: 40px;
      width: 40px;
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      cursor: pointer;
    }
    img {
      width: 18px;
      height: 18px;
    }
  }
  .MuiSvgIcon-root {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;
export default ResultListStyled;
